import { createSelector } from "reselect";
import {isEmpty,map,filter,reverse} from 'lodash'
import moment from 'moment';
const getData = state => {
  const list = state.user.topConnected;

  if(isEmpty(list)){
    return []
  }
  else{
    let data = []

    for (let index = 0; index < 8; index++) {
      let day = moment().subtract(index,'days').utc().toDate()
      const mapped = filter(list,item => {
        return moment(item.createdAt.toDate()).format('MM-DD-YYYY') === moment(day).format('MM-DD-YYYY')
      })

      data.push({name:moment(day).format('MM-DD-YYYY'),users:mapped.length})
    }
    
    return reverse(data);
  }
}

const getMyTopConnectedMembers = createSelector(
  getData,
  topConnected => topConnected
);
export default getMyTopConnectedMembers;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyTopConnectedMembers.js